/**
 * A helper function to split a string into an array based on delimeters in regular expression. By default the 
 * input string will be splitted by one or multiple write space(s), "," and ";".
 * @param {string} inputString that is going to be splitted.
 * @param {RegExp} delimeters that is written in regular expression. By default, the this regular expression
 *  recognize one or multiple write space(s), "," and ";".
 * @returns an array of strings which is splitted from the input string based on delimeters.
 */
const splitStringToArray = (inputString, delimeters = new RegExp("[\\s;,]+")) => {
  if (typeof(inputString) !== "string") {
    return inputString;
  }
  return inputString.split(delimeters);
}

export default splitStringToArray;